import { isMobile } from 'react-device-detect'

export const EXTRA_BOTTOM = isMobile ? 68 : 0
